module.exports = __webpack_public_path__ + "img/frame (53).1de53538.jpg";